/** @type {string} */
const popoverComponent = "Popover";
export default popoverComponent;
